import React, { FC } from 'react';
import { useShopConfig } from '../../../hooks/shopConfig';
import { FontConfigSection } from '../../../types/shopConfig/shopConfigV2';
import MarkdownText from '../../MarkdownText/MarkdownText';
import TypographyWrapper from '../../TypographyWrapper/TypographyWrapper';

interface FAQTextProps {
  children: string;
}

export const FAQTitle: FC<FAQTextProps> = ({ children }) => {
  const { fontConfig } = useShopConfig();
  const typographyVariant = fontConfig[FontConfigSection.AboutPageFAQTitle];

  return (
    <TypographyWrapper
      variant={typographyVariant}
      typographyOverrides={{ style: { fontWeight: 'bold' } }}
    >
      {children}
    </TypographyWrapper>
  );
};

export const FAQDescription: FC<FAQTextProps> = ({ children }) => (
  <TypographyWrapper variant="body1" typographyOverrides={{ style: { whiteSpace: 'pre-wrap' } }}>
    <MarkdownText markdownText={children} />
  </TypographyWrapper>
);
